export default __webpack_public_path__ + "static/media/spotlight.f081324c.svg";